import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";
//List all HouseCategory
export const viewHouseCategory = createAsyncThunk(
  "houseCategory",
  async (thunkAPI) => {
    try {
      let response = await axios.get(`${BaseUrl}dorm-api/house-category`);

      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const registerHouseCategory = createAsyncThunk(
  "houseCategory",
  async (categoryData, thunkAPI) => {
    try {
      let response = await axios.post(
        `${BaseUrl}dorm-api/house-category`,
        categoryData
      );

      // condition
      if (response.status === 201) {
        handleSuccess("Register successfull!");
        return response.data.houseCategory;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

//search HouseCategory
export const singleHouseCategory = createAsyncThunk(
  "houseCategory",
  async (id, thunkAPI) => {
    try {
      // response
      let response = await axios.get(`${BaseUrl}dorm-api/house-category/${id}`);
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError("search category ...");
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
// update HouseCategory
export const updateHouseCategory = createAsyncThunk(
  "houseCategory",
  async (houseCategoryData, thunkAPI) => {
    try {
      // response
      let response = await axios.put(
        `${BaseUrl}dorm-api/house-category/${houseCategoryData.id}`,
        houseCategoryData
      );

      // condition
      if (response.status === 200) {
        handleSuccess("Change successfull!");
        return response.data.houseCategory;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
// Delete HouseCategory
export const deleteHouseCategory = createAsyncThunk(
  "houseCategory",
  async (id, thunkAPI) => {
    try {
      const userInfo = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null;
      let response = await axios.delete(
        `${BaseUrl}dorm-api/house-category/${id}`,
        {
          headers: { Authorization: `Bearer ${userInfo}` },
        }
      );
      if (response.status === 201) {
        handleSuccess("Delete successfull!");
        return response.data.houseCategory;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
